module.exports = __webpack_public_path__ + "static/media/background.1f9b6733.png";